import React from 'react';
import styled from 'styled-components';

import arrowDownIcon from 'images/arrow_down-14x8.png'

export default function GenderAndBirth({
    gender, 
    setGender,
    selectYear,
    setSelectYear,
    selectMonth,
    setSelectMonth,
    selectDate, 
    setSelectDate,
    yearList, 
    monthList, 
    dateList
}) {
    return (
        <GenderAndBirthBlock>
            <GenderSelectBlock>
                <SubTitle>성별 선택</SubTitle>
                <GenderSelectDesc>성별과 연령에 맞는 상품 챌린지를 추천해 드려요</GenderSelectDesc>
                <GenderButtonBlock>
                    <GenderButton isSelect={gender === "m"} onClick={() => setGender('m')}>남성</GenderButton>
                    <GenderButton isSelect={gender === "f"} onClick={() => setGender('f')}>여성</GenderButton>
                </GenderButtonBlock>
            </GenderSelectBlock>
            <BirthSelectBlock>
                <SubTitle>생년 월일</SubTitle>
                <SelectBoxBlock>
                    <SelectBox width={"calc(100vw * (151 / 375))"} value={selectYear} onChange={(e) => setSelectYear(e.target.value)}>
                        {yearList.map((data) => {
                            return (
                                <option key={data.value} value={data.value}>{data.label}</option>
                            )
                        })}
                    </SelectBox>
                    <SelectBox width={"calc(100vw * (84 / 375))"} value={selectMonth} onChange={(e) => setSelectMonth(e.target.value)}>
                        {monthList.map((data) => {
                            return (
                                <option key={data.value} value={data.value}>{data.label}</option>
                            )
                        })}
                    </SelectBox>
                    <SelectBox width={"calc(100vw * (84 / 375))"} value={selectDate} onChange={(e) => setSelectDate(e.target.value)}>
                    {dateList.map((data) => {
                            return (
                                <option key={data.value} value={data.value}>{data.label}</option>
                            )
                        })}
                    </SelectBox>
                </SelectBoxBlock>
            </BirthSelectBlock>
        </GenderAndBirthBlock>
    )
}

const GenderAndBirthBlock = styled.div`
    display: flex;
    flex-direction: column;
    height: 100%;
    padding: 0 calc(100vw * (17 / 375));
`;

const GenderSelectBlock = styled.div`
    margin-top: calc(100vw * (16 / 375));
`;

const SubTitle = styled.h2`
    font-size: calc(100vw * (23 / 375));
    font-weight: 700;
    line-height: calc(100vw * (36 / 375));
    color: #121212;
`;

const GenderSelectDesc = styled.p`
    font-size: calc(100vw * (16 / 375));
    font-weight: 500;
    line-height: calc(100vw * (19 / 375));
    color: #7f7f7f;
    margin-top: calc(100vw * (4 / 375));
`;

const GenderButtonBlock = styled.div`
    display: flex;
    justify-content: space-between;
    width: 100%;
    margin-top: calc(100vw * (27 / 375));
`;

const GenderButton = styled.button`
    width: 100%;
    padding: calc(100vw * (12 / 375)) 0 ;
    background-color: ${({isSelect}) => isSelect ? '#FFF4D8' : '#f7f7f7'};
    border: ${({isSelect}) => isSelect ? '1.5px solid #FFCF19' : '1.5px solid #f7f7f7'};
    border-radius: 5px;
    font-size: calc(100vw * (14 / 375));
    font-weight: 500;
    line-height: calc(100vw * (20 / 375));
    &:last-child {
        margin-left: calc(100vw * (25 / 375));
    }
`;

const BirthSelectBlock = styled.div`
    margin-top: calc(100vw * (50 / 375));
`;

const SelectBoxBlock = styled.div`
    display: flex;
    justify-content: space-between;
    width: 100%;
    margin-top: calc(100vw * (22 / 375));
`;

const SelectBox = styled.select`
    width: ${({width}) => width};
    background: url(${arrowDownIcon}) no-repeat center;
    background-position: center right calc(100vw * (19 / 375));
    background-size: calc(100vw * (10 / 375)) calc(100vw * (6 / 375));
    border: 1px solid #d5d5d5;
    border-radius: 5px;
    padding: calc(100vw * (12 / 375)) calc(100vw * (19 / 375)); 
    vertical-align: top;
`;
